{
  "addressForm": {
    "title": "Titel",
    "firstName": {
      "label": "Voornaam",
      "placeholder": "Voornaam"
    },
    "lastName": {
      "label": "Achternaam",
      "placeholder": "Achternaam"
    },
    "address1": "Adresregel 1",
    "address2": "Adresregel 2 (optioneel)",
    "country": "Land",
    "city": {
      "label": "Stad",
      "placeholder": "Stad"
    },
    "state": "State",
    "zipCode": {
      "label": "Postcode",
      "placeholder": "Postcode"
    },
    "phoneNumber": {
      "label": "Telefonnummer (optional)",
      "placeholder": "(555) 555 - 0123"
    },
    "saveAsDefault": "Als standaard opslaan",
    "chooseAddress": "Choose address",
    "streetAddress": "Adresregel",
    "aptSuite": "Apt, Suite",
    "selectOne": "Land",
    "setAsDefault": "Als standaard opslaan",
    "titleRequired": "Title is required.",
    "userAddressAddSuccess": "Nieuw adres succesvol geregistreerd",
    "userAddressUpdateSuccess": "Adres succesvol geactualiseerd",
    "userAddressDeleteSuccess": "Adres succesvol verwijderd",
    "invalidAddress": "Invalid Address"
  },
  "addressBook": {
    "addNewShippingAddress": "Nieuw adres toevoegen",
    "editShippingAddress": "Verander adres",
    "areYouSureToDeleteAddress": "Weet u zeker dat u dit adres wilt verwijderen?",
    "addNewAddress": "Nieuw adres toevoegen",
    "addAddress": "Adres toevoegen",
    "updateAddress": "Adres bijwerken",
    "backToAddressList": "Terug naar overzicht"
  },
  "addressCard": {
    "default": "STANDAARD",
    "selected": "Selected",
    "setAsDefault": "Als standaard opslaan",
    "shipTo": "Ship To",
    "billTo": "Bill To"
  }
}
